export const course_categoryConstants = {
  REGISTER_REQUEST: 'COURSES_CATEGORY_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'COURSES_CATEGORY_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'COURSES_CATEGORY_REGISTER_FAILURE',

  GET_REQUEST: 'COURSES_CATEGORY_REQUEST',
  GET_SUCCESS: 'COURSES_CATEGORY_SUCCESS',
  GET_FAILURE: 'COURSES_CATEGORY_FAILURE',

  GETALL_REQUEST: 'COURSES_CATEGORY_GETALL_REQUEST',
  GETALL_SUCCESS: 'COURSES_CATEGORY_GETALL_SUCCESS',
  GETALL_FAILURE: 'COURSES_CATEGORY_GETALL_FAILURE',

  DELETE_REQUEST: 'COURSES_CATEGORY_DELETE_REQUEST',
  DELETE_SUCCESS: 'COURSES_CATEGORY_DELETE_SUCCESS',
  DELETE_FAILURE: 'COURSES_CATEGORY_DELETE_FAILURE',
};